import { Control, useController } from "react-hook-form";
import SimpleRadio from "components/shared/inputs/radio";

interface RadioProps {
  name: string;
  control: Control<any>;
  type?: "images" | "default" | "simpleRadio";
  options: Array<{
    value: string;
    icon?: React.ReactElement;
    text: string;
    desc?: string;
    image?: string | null;
    needDarkImage?: boolean;
    disabled?: boolean;
    descColor?: string;
    textColor?: string;
  }>;
}

export const Radio: React.FC<RadioProps> = ({
  name,
  control,
  options,
  type = "default",
}) => {
  const { field } = useController({ control, name });
  if (type === "default") {
    return (
      <div className="option_bar custom" data-length="autofit">
        {options.map((o) => (
          <label className="" data-length="430" key={o.value}>
            <input
              type="radio"
              value={o.value}
              name={field.name}
              onChange={field.onChange}
              {...(o.value === field.value ? { checked: true } : {})}
              ref={field.ref}
              disabled={o.disabled}
            />
            <wrap
              data-gap="15"
              data-min-height="72"
              data-name={
                field.value === undefined || field.value === null
                  ? "inactive"
                  : ""
              }
            >
              <group
                data-align="center"
                data-length="80"
                data-justify="center"
                data-height="40"
                data-radius="extra-special"
                data-background="main"
                data-color="white"
              >
                <icon data-svg-size="48x" data-svg-color="white">
                  {o.icon}
                </icon>
              </group>
              <group
                data-width="auto"
                data-length="autofit"
                data-direction="column"
                data-contain=""
              >
                <text
                  data-text-size="large"
                  data-weight="600"
                  data-contain=""
                  data-ellipsis=""
                  data-color={o.textColor}
                >
                  {o.text}
                </text>
                <text
                  className=""
                  data-wrap="wrap"
                  data-text-size="12"
                  data-contain=""
                  data-ellipsis=""
                  data-color={o.descColor}
                  style={{
                    opacity: o.descColor ? 1 : undefined,
                  }}
                >
                  {o.desc}
                </text>
              </group>
            </wrap>
          </label>
        ))}
      </div>
    );
  }

  if (type === "images") {
    return (
      <group data-wrap="no" data-gap="20">
        <group data-length="autofit">
          <group data-gap="30">
            <div className="option_bar custom image" data-length="autofit">
              {options.map((o) => (
                <label className="" data-length="260" key={o.value}>
                  <input
                    type="radio"
                    value={o.value}
                    name={name}
                    onChange={field.onChange}
                    {...(o.value === field.value ? { checked: true } : {})}
                    ref={field.ref}
                  />
                  <wrap data-gap="15" data-min-height="72" data-name="inactive">
                    <group
                      data-gap="10"
                      data-radius="extra-special"
                      data-contain=""
                    >
                      <group
                        data-gap="20"
                        data-height="100"
                        data-interactive=""
                        data-cursor="pointer"
                      >
                        <picture data-position="absolute">
                          <img src={o.image ?? ""} alt="" />
                        </picture>
                        {o.needDarkImage && (
                          <group
                            data-position="absolute"
                            data-background="linear-middark-bottom"
                            data-height="fit"
                          ></group>
                        )}
                        <group
                          data-width="auto"
                          data-height="autofit"
                          data-space="20"
                          data-gap="10"
                          data-direction="column"
                        >
                          <text
                            data-position="bottom"
                            data-text-size="large"
                            data-color={o.textColor ?? "white"}
                          >
                            {o.text}
                          </text>
                        </group>
                      </group>
                    </group>
                  </wrap>
                </label>
              ))}
            </div>
          </group>
        </group>
      </group>
    );
  }

  if (type === "simpleRadio") {
    return (
      <div>
        <group data-gap="1" data-contain="" data-direction="column">
          {options.map((o) => (
            <group data-width="auto" data-space="10">
              {" "}
              <SimpleRadio
                name={field.name}
                radioValue={o.value}
                label={o.text}
                control={control}
              />
            </group>
          ))}
        </group>
      </div>
    );
  }
};
